const storage = {
  // 设置缓存
  localSet: (name: string, data: any): void => {
    localStorage.removeItem(name);
    localStorage.setItem(name, JSON.stringify(data));
  },
  // 获取缓存
  localGet: (name: string) => {
    const result = localStorage.getItem(name);
    if (result) {
      return JSON.parse(result);
    } else {
      return result;
    }
  },
  // 清除缓存
  localRemove: (name: string): void => {
    localStorage.removeItem(name);
  },
  sessionSet: (name: string, data: any) => {
    sessionStorage.removeItem(name);
    sessionStorage.setItem(name, JSON.stringify(data));
  },
  sessionGet: (name: string) => {
    const result = sessionStorage.getItem(name);
    if (result) {
      return JSON.parse(result);
    } else {
      return result;
    }
  },
  sessionRemove: (name: string) => {
    sessionStorage.removeItem(name);
  },
};
export default storage;
